'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { useCertificadoAcessosSentenca } from '../../hooks/useCertificadoAcessosSentenca';
import type { DocumentoEncerramentoContainerProps } from '../../types/encerramento.types';
import { rotaProcessoPorOrigem } from '../../utils/rotaProcessoPorOrigem';
import { CertificadoAcessosSentencaView } from './certificado-acessos-sentenca/CertificadoAcessosSentencaView';
export function CertificadoAcessosSentencaContainer(t0) {
  const $ = _c(15);
  const {
    processoId,
    origem
  } = t0;
  const router = useRouter();
  const {
    certificado,
    isLoading,
    error,
    semPermissao,
    naoPublicada,
    recarregar,
    isDownloadingPdf,
    baixarPdf,
    imprimir
  } = useCertificadoAcessosSentenca(processoId, origem);
  let t1;
  if ($[0] !== origem || $[1] !== processoId || $[2] !== router) {
    t1 = () => {
      router.push(rotaProcessoPorOrigem(origem, processoId));
    };
    $[0] = origem;
    $[1] = processoId;
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleVoltar = t1;
  let t2;
  if ($[4] !== baixarPdf || $[5] !== certificado || $[6] !== error || $[7] !== handleVoltar || $[8] !== imprimir || $[9] !== isDownloadingPdf || $[10] !== isLoading || $[11] !== naoPublicada || $[12] !== recarregar || $[13] !== semPermissao) {
    t2 = <CertificadoAcessosSentencaView certificado={certificado} error={error} isDownloadingPdf={isDownloadingPdf} isLoading={isLoading} naoPublicada={naoPublicada} onBaixarPdf={baixarPdf} onImprimir={imprimir} onTentarNovamente={recarregar} onVoltar={handleVoltar} semPermissao={semPermissao} />;
    $[4] = baixarPdf;
    $[5] = certificado;
    $[6] = error;
    $[7] = handleVoltar;
    $[8] = imprimir;
    $[9] = isDownloadingPdf;
    $[10] = isLoading;
    $[11] = naoPublicada;
    $[12] = recarregar;
    $[13] = semPermissao;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
}